<div class="forgot-password-container">
  <!-- Left side - Background -->
  <div class="forgot-password-left">
  </div>
  
  <!-- Right side - Forgot Password Card -->
  <div class="forgot-password-right">
    <div class="forgot-password-form-container">
      <div class="form-branding">
        <img src="/images/DSDN_Images/desimonelogogreytrans.png" alt="DeSimone" class="form-logo">
        <img src="/images/DSDN_Images/strurcturaldn.png" alt="Structural Detailer Network" class="form-text">
      </div>
      
      <!-- Before email sent -->
      <div *ngIf="!emailSent" class="forgot-password-content">
        <h2 class="forgot-password-title">Forgot Password?</h2>
        <p class="forgot-password-description">
          Click the button below to send a password reset link to your email address on file.
        </p>
        
        <div *ngIf="maskedEmail" class="masked-email-display">
          <svg class="email-icon" viewBox="0 0 20 20" fill="currentColor">
            <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
            <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
          </svg>
          <span>{{ maskedEmail }}</span>
        </div>

        <div *ngIf="error" class="error-message">
          <svg class="error-icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
          </svg>
          {{ error }}
        </div>

        <button 
          class="btn-send-reset" 
          (click)="sendResetLink()"
          [disabled]="loading"
        >
          <span *ngIf="!loading">Send Reset Link</span>
          <span *ngIf="loading" class="loading-content">
            <svg class="spinner-icon" viewBox="0 0 24 24">
              <circle class="spinner-circle" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" fill="none"/>
            </svg>
            Sending...
          </span>
        </button>

        <a class="back-to-login-link" (click)="backToLogin()">
          <svg class="back-icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clip-rule="evenodd"/>
          </svg>
          Back to Login
        </a>
      </div>

      <!-- After email sent -->
      <div *ngIf="emailSent" class="success-content">
        <div class="success-icon-container">
          <svg class="success-icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
          </svg>
        </div>
        
        <h2 class="success-title">Check Your Email</h2>
        <p class="success-description">
          A password reset link has been sent to
        </p>
        <div class="success-email">{{ maskedEmail }}</div>
        <p class="success-note">
          Please check your inbox and click the link to reset your password. The link will expire in 24 hours.
        </p>

        <button class="btn-back-login" (click)="backToLogin()">
          Back to Login
        </button>

        <div class="resend-section">
          <span class="resend-text">Didn't receive the email?</span>
          <a class="resend-link" (click)="sendResetLink()">Resend</a>
        </div>
      </div>
    </div>
  </div>
</div>
